import { styled } from '@mui/material';
import { DateRangePicker, DateRangePickerProps } from '@mui/x-date-pickers-pro';

export const DateRangePickerCellStyled = styled((props: DateRangePickerProps<Date>) => <DateRangePicker {...props} />)({
  flex: 1,
  fieldset: {
    border: 0,
  },
});
